// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-ae134114] .avue-crud__pagination .el-pagination{display:inline-block!important}[data-v-ae134114] .el-dialog__header{border-bottom:1px solid #ebebeb;padding-bottom:15px}[data-v-ae134114] .el-dialog__body{padding:0}[data-v-ae134114] .el-table td .is-left{padding-left:20px}", ""]);
// Exports
module.exports = exports;
